import ko from "lib/knockout";
import {newLogger} from "core/utils/logger";
import {MainInput} from "../../../core/components/maininput";
import 'lib/slick-carousel';
import 'lib/soon-countdown';

const logger = newLogger('Landing/main');

export function init(options) {
	initMainInput(options);
	initSlider();
	initDockMenu();

	const $screen = $('#main-screen');
	$screen.find('.toggle-icon').click(function () {
		$screen.find('.menu').toggleClass('pushed');
	});
}

function initMainInput(options) {
	const rootNode = document.getElementById('searchRoot');
	const $container = $('#search');
	const model = new MainInput({
		containerSelector: $container,
		orderFormSelector: $container.find('.formOrder'),
		checkingTypes: options.checkingTypes
	});
	ko.applyBindings(model, rootNode);
}

function initSlider() {
	const $share_section = $('#main-screen').find('.share-block');
	$share_section.removeClass('before-slick-init');
	const $slider = $share_section.find('.share-slider');
	if ($slider.closest('.single').length > 0) {
		return;
	}
	$slider.slick({
		// fade: true,
		autoplay: true,
		autoplaySpeed: 10000,
		dots: true
	}).on('afterChange', function () {
		const date = $(this).find('.slick-current').find('.share-slide').data('due');
		$('.share-left .soon').soon().setOption('due', date);
	});
}

function initDockMenu() {
	const $container = $('#main-screen').find(".dock-container");
	$container.find(".dock-item").each(function () {
		$(this).hover(
			function () {
				$(this).prev(".dock-item").addClass("nearby");
				$(this).next(".dock-item").addClass("nearby");
			},
			function () {
				$(this).prev(".dock-item").removeClass("nearby");
				$(this).next(".dock-item").removeClass("nearby");
			}
		);
	});

	const $movingLine = $container.find('.moving-line');
	if ($movingLine.length > 0) {
		$container.mouseover(function (e) {
			const offset = $(this).offset();
			const relativeX = (e.pageX - offset.left);
			$movingLine.css('left', relativeX);
		});
	}
}



// WEBPACK FOOTER //
// ./modules/landing/sections/main.js